<template>
  <div class="quote-resources" ref='list'>
    <p>撮影リスト</p>
    <div class='empty' v-if='nullResult'>現在資料が登録されていません。</div>
    <ul>
      <li v-for='(resource, index) in resources' :key='index'>
        <img v-if='resource.type === 0' :src="resource.url">
        <video v-if='resource.type === 1' playsinline autoplay muted loop>
          <source :src="resource.url" type='video/mp4'>
        </video>
        <button type="button" class="btn btn-danger trash" :disabled="loading" @click="deleteResource(resource.id)">
          削除
        </button>
      </li>
    </ul>
    <div class="floating-actions">
      <button class="btn" type='button'
              :disabled='loading'
              @click='addResource'>
        資料を追加
      </button>
    </div>
  </div>
</template>

<script>
  import Morescroll     from '@/lib/morescroll'

  var   scrollControllerResources = null;

  export default {
    name: "OrderQuoteResources",
    data: function () {
      return {
        resources: [],
        total: 1,
        loadCount: 0,
        loading: false
      }
    },
    methods: {
      load: function () {
        if (this.total <= this.resources.length) return false;
        this.loading = true;
        this.$api
          .getOrderQuoteResources(this.loadCount + 1, this.$route.params.id)
          .then((res) => {
            this.loading = false;
            this.resources = this.resources.concat(res.data.data.results);
            this.total = res.data.data.pagination.total;
            this.loadCount++;
          })
      },
      refresh: function () {
        this.resources = [];
        this.total = 1;
        this.loadCount = 0;
        this.load();
      },
      addResource: function() {
        this.$router.push({name: 'orderQuoteResourceCreate', params: this.$route.params});
      },
      deleteResource: function(resource_id) {
        this.$$.alert({
          message: '削除しますか？',
          actionText: 'はい',
          cancelText: 'いいえ',
          action: () => {
            this.loading = true;
            this.$api.deleteOrderQuoteResource(this.$route.params.id, resource_id)
              .then(()=>{
                this.loading = false;
                this.$$.flash();
                this.refresh();
              })
              .catch(() => {
                this.loading = false;
              });
          },
          cancelAction: () => null,
        })
      }
    },
    computed: {
      nullResult: function() {
        return this.loadCount > 0 && this.resources.length == 0;
      }
    },
    mounted: function () {
      this.$$.context({
        title: "資料撮影:" + this.$route.params.id,
        previousRouteName: 'orderQuoteSteps',
      });
      scrollControllerResources = new Morescroll({
        el: this.$refs.list,
        onOverScroll: () => {
          this.refresh();
        },
        onScrollBottom: () => {
          this.load();
        }
      })
      this.refresh();
    },
    beforeDestroy: function() {
      if (scrollControllerResources) {
        scrollControllerResources.destroy();
      }
    }
  }
</script>

<style lang='scss'>
  .quote-resources {
    &__upload {
      padding: 1em;
      text-align: center;
    }
    ul {
      margin-bottom: 120px;
      li {
        display: block;
        width: 100%;
        padding: 24px 8px;
        background: #fafafa;
        min-height: 240px;
      }
    }
    p {
      text-align: left;
      padding: 4px 16px;
      font-size: 12px;
      color: #888;
      background: #eee;
    }
    img {
      margin: auto;
      display: block;
      max-width: 100%;
      max-height: 100%;
      position: relative;
    }
    video {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      display: block;
      margin: auto;
      position: relative;
    }
    .empty {
      padding: 30px;
      text-align: center;
    }
    .trash {
      margin: 4px;
      float: right;
    }
  }
</style>